<template>
  <va-show-layout>
    <va-show :item="item">
      <v-row justify="center">
        <v-col lg="8">
          <base-material-card>
            <template #heading>
              <div class="display-2">
                {{ title }}
              </div>
            </template>
            <v-card-text>
              <v-row>
                <v-col>
                  <va-field source="language"></va-field>
                  <va-field source="languageCode"></va-field>
                </v-col>
                <v-col>
                  <va-field source="createdAt" type="date" class="mt-0 pt-0">
                    {{ new Date(item.createdAt).toLocaleDateString('en-CA') }}
                  </va-field>
                  <va-field source="lastUpdatedAt" type="date">
                    {{ new Date(item.lastUpdatedAt).toLocaleDateString('en-CA') }}
                  </va-field>
                </v-col>
              </v-row>
            </v-card-text>
          </base-material-card>
        </v-col>
      </v-row>
    </va-show>
  </va-show-layout>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      default: '',
    },
    item: {
      type: Object,
      default: null,
    },
  },
};
</script>
